import React from 'react'
import {getLocal, setLocal} from '../../../hooks/useStorage/useStorage.jsx'

import {
    CardMedia,
    Divider,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from '@mui/material'
import {
    GTranslateRounded as GTranslateIcon,
    ClearAllRounded as ClearAllIcon,
    HistoryRounded as HistoryIcon,
    PersonRounded as PersonIcon
} from '@mui/icons-material'

import {general as textsGeneral} from '../../../translate/Translate.jsx'

import icon from '../../../assets/icon.svg'
import bitbar from '../../../assets/bitbar.svg'

import './menuDrawer.scss'

const nameStore = import.meta.env.VITE_NAME_STORE
const versionName = import.meta.env.VITE_VERSION_NAME

const MenuDrawer = ({openDrawer, onClose, onClick}) => {
    const handleClickItem = (item) => onClick(item)

    const handleClickVersion = () => {
        const search = getLocal('search')
        let modeDesenv = getLocal('modeDesenv', 0)
        if (++modeDesenv >= 3) {
            alert(search)
            setLocal('modeDesenv', 0)
        } else {
            setLocal('modeDesenv', modeDesenv)
            console.table(JSON.parse(search))
        }
    }
    return <div>
        <Drawer
            variant={'temporary'}
            anchor={'left'}
            open={openDrawer}
            onClose={onClose}>
            <div className={'div-drawer'}>
                <CardMedia image={icon} className={'icon-drawer'}/>
                <label className={'label-title'}>
                    {nameStore}
                </label>
            </div>
            <List>
                <ListItem>
                    <ListItemButton onClick={() => handleClickItem('profile')}>
                        <ListItemIcon>
                            <PersonIcon className={'item-icon-drawer'}/>
                        </ListItemIcon>
                        <ListItemText className={'item-text-drawer'} primary={textsGeneral.profile}/>
                    </ListItemButton>
                </ListItem>
                <Divider/>
                <ListItem>
                    <ListItemButton onClick={() => handleClickItem('orderHistory')}>
                        <ListItemIcon>
                            <HistoryIcon className={'item-icon-drawer'}/>
                        </ListItemIcon>
                        <ListItemText className={'item-text-drawer'} primary={textsGeneral.orderHistory}/>
                    </ListItemButton>
                </ListItem>
                <Divider/>
                <ListItem>
                    <ListItemButton onClick={() => handleClickItem('language')}>
                        <ListItemIcon>
                            <GTranslateIcon className={'item-icon-drawer'}/>
                        </ListItemIcon>
                        <ListItemText className={'item-text-drawer'} primary={textsGeneral.language}/>
                    </ListItemButton>
                </ListItem>
                <Divider/>
                <ListItem>
                    <ListItemButton onClick={() => handleClickItem('clearData')}>
                        <ListItemIcon>
                            <ClearAllIcon className={'item-icon-drawer'}/>
                        </ListItemIcon>
                        <ListItemText className={'item-text-drawer'} primary={textsGeneral.clearData}/>
                    </ListItemButton>
                </ListItem>
                <Divider/>
                <ListItem onClick={handleClickVersion}>
                    <CardMedia image={bitbar} className={'logo'}/>
                    <ListItemText className={'item-text-drawer'} primary={`${textsGeneral.copyright}`}/>
                </ListItem>
                <div className={'div-version'} onClick={()=> {}}>
                    <label>
                        {`${textsGeneral.version}: ${versionName}`}
                    </label>
                </div>
            </List>
        </Drawer>
    </div>
}

export default MenuDrawer
